// @generated by protoc-gen-es v1.0.0 with parameter "rewrite_imports=./google/api/**/*_pb.js:@buf/googleapis_googleapis.bufbuild_es,rewrite_imports=./gogoproto/**/*_pb.js:@buf/cosmos_gogo-proto.bufbuild_es,rewrite_imports=./cosmos_proto/**/*_pb.js:@buf/cosmos_cosmos-proto.bufbuild_es"
// @generated from file cosmos/staking/v1beta1/tx.proto (package cosmos.staking.v1beta1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, proto3, Timestamp } from "@bufbuild/protobuf";
import { CommissionRates, Description, Params } from "./staking_pb.js";
import { Coin } from "../../base/v1beta1/coin_pb.js";

/**
 * MsgCreateValidator defines a SDK message for creating a new validator.
 *
 * @generated from message cosmos.staking.v1beta1.MsgCreateValidator
 */
export const MsgCreateValidator = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgCreateValidator",
  () => [
    { no: 1, name: "description", kind: "message", T: Description },
    { no: 2, name: "commission", kind: "message", T: CommissionRates },
    { no: 3, name: "min_self_delegation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "delegator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "validator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "pubkey", kind: "message", T: Any },
    { no: 7, name: "value", kind: "message", T: Coin },
  ],
);

/**
 * MsgCreateValidatorResponse defines the Msg/CreateValidator response type.
 *
 * @generated from message cosmos.staking.v1beta1.MsgCreateValidatorResponse
 */
export const MsgCreateValidatorResponse = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgCreateValidatorResponse",
  [],
);

/**
 * MsgEditValidator defines a SDK message for editing an existing validator.
 *
 * @generated from message cosmos.staking.v1beta1.MsgEditValidator
 */
export const MsgEditValidator = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgEditValidator",
  () => [
    { no: 1, name: "description", kind: "message", T: Description },
    { no: 2, name: "validator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "commission_rate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "min_self_delegation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgEditValidatorResponse defines the Msg/EditValidator response type.
 *
 * @generated from message cosmos.staking.v1beta1.MsgEditValidatorResponse
 */
export const MsgEditValidatorResponse = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgEditValidatorResponse",
  [],
);

/**
 * MsgDelegate defines a SDK message for performing a delegation of coins
 * from a delegator to a validator.
 *
 * @generated from message cosmos.staking.v1beta1.MsgDelegate
 */
export const MsgDelegate = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgDelegate",
  () => [
    { no: 1, name: "delegator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "validator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "message", T: Coin },
  ],
);

/**
 * MsgDelegateResponse defines the Msg/Delegate response type.
 *
 * @generated from message cosmos.staking.v1beta1.MsgDelegateResponse
 */
export const MsgDelegateResponse = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgDelegateResponse",
  [],
);

/**
 * MsgBeginRedelegate defines a SDK message for performing a redelegation
 * of coins from a delegator and source validator to a destination validator.
 *
 * @generated from message cosmos.staking.v1beta1.MsgBeginRedelegate
 */
export const MsgBeginRedelegate = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgBeginRedelegate",
  () => [
    { no: 1, name: "delegator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "validator_src_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "validator_dst_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "amount", kind: "message", T: Coin },
  ],
);

/**
 * MsgBeginRedelegateResponse defines the Msg/BeginRedelegate response type.
 *
 * @generated from message cosmos.staking.v1beta1.MsgBeginRedelegateResponse
 */
export const MsgBeginRedelegateResponse = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgBeginRedelegateResponse",
  () => [
    { no: 1, name: "completion_time", kind: "message", T: Timestamp },
  ],
);

/**
 * MsgUndelegate defines a SDK message for performing an undelegation from a
 * delegate and a validator.
 *
 * @generated from message cosmos.staking.v1beta1.MsgUndelegate
 */
export const MsgUndelegate = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgUndelegate",
  () => [
    { no: 1, name: "delegator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "validator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "message", T: Coin },
  ],
);

/**
 * MsgUndelegateResponse defines the Msg/Undelegate response type.
 *
 * @generated from message cosmos.staking.v1beta1.MsgUndelegateResponse
 */
export const MsgUndelegateResponse = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgUndelegateResponse",
  () => [
    { no: 1, name: "completion_time", kind: "message", T: Timestamp },
    { no: 2, name: "amount", kind: "message", T: Coin },
  ],
);

/**
 * MsgCancelUnbondingDelegation defines the SDK message for performing a cancel unbonding delegation for delegator
 *
 * Since: cosmos-sdk 0.46
 *
 * @generated from message cosmos.staking.v1beta1.MsgCancelUnbondingDelegation
 */
export const MsgCancelUnbondingDelegation = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgCancelUnbondingDelegation",
  () => [
    { no: 1, name: "delegator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "validator_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "message", T: Coin },
    { no: 4, name: "creation_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * MsgCancelUnbondingDelegationResponse
 *
 * Since: cosmos-sdk 0.46
 *
 * @generated from message cosmos.staking.v1beta1.MsgCancelUnbondingDelegationResponse
 */
export const MsgCancelUnbondingDelegationResponse = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgCancelUnbondingDelegationResponse",
  [],
);

/**
 * MsgUpdateParams is the Msg/UpdateParams request type.
 *
 * Since: cosmos-sdk 0.47
 *
 * @generated from message cosmos.staking.v1beta1.MsgUpdateParams
 */
export const MsgUpdateParams = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgUpdateParams",
  () => [
    { no: 1, name: "authority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "params", kind: "message", T: Params },
  ],
);

/**
 * MsgUpdateParamsResponse defines the response structure for executing a
 * MsgUpdateParams message.
 *
 * Since: cosmos-sdk 0.47
 *
 * @generated from message cosmos.staking.v1beta1.MsgUpdateParamsResponse
 */
export const MsgUpdateParamsResponse = proto3.makeMessageType(
  "cosmos.staking.v1beta1.MsgUpdateParamsResponse",
  [],
);

